export const getCheckoutSteps = (event) => {
  if (event?.has_seating) {
    return [{text: 'ORDER'}, {text: 'DETAILS'}, {text: 'SEATS'}, {text: 'PAYMENT'}]
  }

  return [{text: 'ORDER'}, {text: 'DETAILS'}, {text: 'PAYMENT'}]
};

/**
 * True when checkout should show the custom-fields step: event-level custom fields
 * and/or per-ticket-type custom fields on any selected ticket line (count > 0).
 */
export const needsCustomFieldsStep = (event, selectedTickets) => {
  if (event?.custom_fields?.length > 0) {
    return true;
  }

  const lines = selectedTickets?.selectedTickets;
  if (!lines || typeof lines !== 'object') {
    return false;
  }

  return Object.values(lines).some(
    (line) =>
      line &&
      line.count > 0 &&
      Array.isArray(line.custom_fields) &&
      line.custom_fields.length > 0
  );
};